import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import PurchaseOrderListView from '@components/shared/purchaseOrders/PurchaseOrderListView'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService'
import ListPageHeader from '@shared/ListPageHeader'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { purchaseOrderService } from '@services/operator/purchaseOrderService'

export default function OperatorPurchaseOrderList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const { addJob } = useOperatorNotification()
  const isStandard = useIsStandard()
  const supplierService = useOperatorSupplierService()

  return (
    <div>
      <ListPageHeader
        items={['purchase_orders', 'purchase_orders.list']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/purchase_orders/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <PurchaseOrderListView
        service={purchaseOrderService}
        role="operator"
        showMerchantColumn={!isStandard}
        merchants={merchants}
        supplierService={supplierService}
        addJob={addJob}
      />
    </div>
  )
}
